











































































































































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class EditContatto extends Vue {
	@Prop() contatto?: Contatto;
	@Prop({ default: true }) editableAddress!: boolean;

	@Inject('CrudService') contattoCrudService!: CrudService<Contatto>;

	newContatto!: Contatto;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	comuneSearch: Search = new Search('comuni');
	provincia: Provincia | null = null;
	comune: Comune | null = null;

	maxDate!: Date;

	constructor() {
		super();
		this.newContatto = new Contatto();
		this.maxDate = new Date();
	}

	beforeMount() {
		if (this.contatto) {
			if (this.contatto.id) {
				this.newContatto = cloneDeep(this.contatto);
				if (this.newContatto.province) {
					this.provincia = new Provincia();
					this.provincia.descrizione = this.newContatto.province;
				}
				if (this.newContatto.comune) {
					this.comune = new Comune();
					this.comune.descrizione = this.newContatto.comune;
				}
			} else {
				this.newContatto = new Contatto();
			}
		}
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.newContatto.province = this.provincia.descrizione;
			this.newContatto.comune = '';
			this.comuneSearch.addSimpleFilter('provincia', this.provincia.descrizione as string);
		}
	}

	onComuneChange() {
		if (this.comune) this.newContatto.comune = this.comune.descrizione;
	}

	submit() {
		this.$emit('submit', this.newContatto);
	}

	close() {
		(this.$parent as any).close();
	}

}
